import SpaceY from '../../../../components/SpaceY';
import {
  MAX_WIDTH_639PX,
  s3CloudFrontUrlEndpoint,
} from '../../../../utils/common';
import useClientMediaQuery from '../../../../utils/hook/useClientMediaQuery';
import MissionReactSlick from '../MissionReactSlick';

const SourcingFirstSection = () => {
  const isMobile = useClientMediaQuery({ query: MAX_WIDTH_639PX });

  const SLIDER_IMAGES = Array.from(
    { length: isMobile ? 5 : 2 },
    (_, i) =>
      `${s3CloudFrontUrlEndpoint}/mission/sourcing-slider/${
        isMobile ? 'mo' : 'pc'
      }${i}.png`,
  );

  return (
    <div>
      {isMobile ? (
        <h3 className="text-center text-22px font-bold leading-[30.8px] text-gray-800">
          이런 농산물을 다룹니다
        </h3>
      ) : (
        <h2 className="text-center text-26px font-bold text-gray-800">
          이런 농산물을 다룹니다
        </h2>
      )}

      <SpaceY height={isMobile ? 48 : 32} />
      <p className="text-18px leading-[28.8px] text-brand-1 sm:text-center">
        어글리어스는 산지의 문제를 해결하고 산지와 소비자를 더 가깝게 연결하고자
        합니다.
        <br />
        <br />
        긴급하게 판로가 필요한 농산물부터 친환경 생산 철학을 지지하며 자란
        농산물까지,{isMobile ? ' ' : <br />}기존의 시장 기준과 관행을 깨고
        어글리어스만의 소싱 원칙으로 새로운 유통 체계를 만들어갑니다.
      </p>

      <SpaceY height={48} />
      <MissionReactSlick id="sourcing-slider" sliderImages={SLIDER_IMAGES} />
    </div>
  );
};

export default SourcingFirstSection;
